import {app} from "./components/app.ts";

const container = document.body;
container.appendChild(app());